module.exports = __webpack_public_path__ + "static/media/Surrounding9.d0fe51e3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Surrounding9.jpeg
// module id = 582
// module chunks = 0